import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import AppManager from '../views/AppManager.vue';
import PublicApp from '../views/PublicApp.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import { useAuthStore } from '../stores/authStore';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true, title: 'AP Kütüphane - Giriş' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresGuest: true, title: 'AP Kütüphane - Şifre Sıfırlama' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresGuest: true, title: 'AP Kütüphane - Yeni Şifre' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, title: 'AP Kütüphane - Kontrol Paneli' }
  },
  {
    path: '/app/:appId/manage',
    name: 'AppManager',
    component: AppManager,
    meta: { requiresAuth: true, title: 'AP Kütüphane - Kitaplık Yönetimi' }
  },
  {
    path: '/app/:id',
    name: 'PublicApp',
    component: PublicApp,
    meta: { title: 'AP Kütüphane - Dosyalar' }
  },
  {
    path: '/app/:id/file/:fileId',
    name: 'FilePreview',
    component: () => import('../views/FilePreview.vue'),
    meta: { title: 'AP Kütüphane - Dosya Önizleme' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guards
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();
  
  // Wait for auth initialization if still loading
  if (authStore.loading) {
    // Wait for auth to complete initialization
    while (authStore.loading) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  }
  
  const requiresAuth = to.matched.some(record => record.meta?.requiresAuth);
  const requiresGuest = to.matched.some(record => record.meta?.requiresGuest);
  
  // Set document title
  const title = to.meta?.title as string;
  if (title) {
    document.title = title;
  } else {
    document.title = 'AP Kütüphane';
  }
  
  if (requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } else if (requiresGuest && authStore.isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }
});

export default router; 